<main class="c-login-page">
    <div class="c-login">
        <div unauthenticatedHeader class="c-main-nav-wrapper c-main-nav-wrapper--login"></div>
        <h1 class="c-heading u-mtop-mobile-md">No active cases</h1>
        <p class="c-text-width">You don't currently have any cases. Please check back later or call our technical support line at <minster-link href="tel:{{contact.telephone}}" [text]="contact.telephone"></minster-link></p>
        <div class="u-mtop-ism">
            <minster-link [mlRouterLink]="['/auth/logout']" text="Back to login"></minster-link>
        </div>
    </div>
    <div unauthenticatedImageContainer></div>
</main>
<footer class="c-footer c-footer--login">
    <ul class="c-footer__content">
        <li class="c-footer__items"><a class="c-text-link c-text-link--white" href="https://www.minsterlaw.co.uk/privacy-notice/" target="_blank">Privacy Notice</a></li>
        <li class="c-footer__items"><a class="c-text-link c-text-link--white" href="https://www.minsterlaw.co.uk/cookie-policy/" target="_blank">Cookie Policy</a></li>
    </ul>
</footer>
